import axios from 'axios';

let prefix = "/equipment-config"

const EquipmentConfigApi = {
	getSlotStats() {
		return axios.get(prefix + "/slot-stats")
	},
	setSlotStats(payload) {
		// payload: { slots: { HELMET: [...], BODY: [...], ... } }
		return axios.post(prefix + "/slot-stats", payload)
	},
	getSubstatConfigs() {
		return axios.get(prefix + "/substat-configs")
	},
	setSubstatConfigs(payload) {
		return axios.post(prefix + "/substat-configs", payload)
	},
	getUpgradeCosts() {
		return axios.get(prefix + "/upgrade-costs")
	},
	setUpgradeCosts(payload) {
		return axios.post(prefix + "/upgrade-costs", payload)
	},
}

export default EquipmentConfigApi;
